import React, {Fragment} from 'react'
//Material UI Components
import {makeStyles} from "@material-ui/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import {Dialog, Grid, IconButton, Slide, Typography} from "@material-ui/core";
//Material Ui Icons
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
    title: {
        margin: 0,
        padding: theme.spacing(0),
        paddingLeft: theme.spacing(1),
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
    },
    closeButton: {
        color: theme.palette.common.white
    },
}));


const DialogTitle = ({children, onClose, ...props}) => {
    const classes = useStyles();

    return (
        <MuiDialogTitle className={classes.title} disableTypography  {...props}>
            <Grid container justify="space-between" alignItems={'center'}>
                <Grid item> <Typography variant='h6'>{children}</Typography> </Grid>
                <Grid item>
                    {
                        onClose && <IconButton className={classes.closeButton} onClick={onClose}>
                            <CloseIcon/>
                        </IconButton>
                    }
                </Grid>
            </Grid>
        </MuiDialogTitle>
    )
};

export default function MemberDialog({dialogStatus, children, fullWidth, title, handleClose, maxWidth, fullScreen}) {
    return (
        <Fragment>
            <Dialog aria-labelledby="responsive-dialog-title" fullScreen={fullScreen} open={dialogStatus}
                    TransitionComponent={Slide}
                    fullWidth={fullWidth} maxWidth={maxWidth}>
                <DialogTitle id="responsive-dialog-title" onClose={handleClose}>
                    {title}
                </DialogTitle>
                {children}
            </Dialog>
        </Fragment>
    )
};